import { render, staticRenderFns } from "./NewsThree.vue?vue&type=template&id=9a82486a&scoped=true"
import script from "./NewsThree.vue?vue&type=script&lang=js"
export * from "./NewsThree.vue?vue&type=script&lang=js"
import style0 from "./NewsThree.vue?vue&type=style&index=0&id=9a82486a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a82486a",
  null
  
)

export default component.exports